import React from 'react'

import { useMqrFilters } from 'hooks/useMqrFilters'
import { mqrApi } from 'redux/services/mqr'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { COMMON_STATUS_TEXT } from 'constants/common'
import { Mqr } from 'models/mqr'

import { formatDate } from 'shared/libs'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'
import { EmptyDetails } from 'shared/ui'

export const MqrPage = () => {
  const { params, setParam, resetParams } = useMqrFilters()
  const [selectedRowId, setSelectedRowId] = React.useState<
    Mqr['id'] | undefined
  >()
  const [fetch, fetchState] = mqrApi.useLazyGetMqrsQuery()

  React.useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
  }
  const reset = () => {
    resetParams()
    fetch(params)
  }

  return (
    <>
      <AppLayoutTable
        title="MQR"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              key={selectedRowId}
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                  width: 50,
                },
                {
                  data: 'Название',
                  key: 'name',
                  width: 50,
                },
                {
                  data: 'Дата',
                  key: 'created_at',
                  width: 50,
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'JIRA',
                  key: 'jira_key',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, row) => {
                    return COMMON_STATUS_TEXT[row.status]
                  },
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
